import React from "react";
import { DailyIcon } from "@/features/daily/components/DailyIcon";
import type { QuietHourVm } from "@/features/daily/components/command/health-view-model";

/** D108: a quiet hour the baseline expects — said calmly, with what was expected and seen. */
export const QuietHourNote: React.FC<{ quiet: QuietHourVm | null }> = ({ quiet }) =>
    quiet === null ? null : (
        <p className="daily-summary daily-quiet" role="status">
            <DailyIcon name="bedtime" /> <strong>{quiet.text}</strong>
            {quiet.detail === null ? null : <span className="daily-small daily-muted"> · {quiet.detail}</span>}
        </p>
    );
